import React, { memo, useEffect, useRef, useState } from "react";
import styles from "./DashboardInput.module.css";
import { LocalizationProvider, MobileTimePicker } from "@mui/x-date-pickers";
import InfoIcon from "@mui/icons-material/Info";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { ThemeProvider, createTheme } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const DTextInput = ({
  label,
  required = false,
  type,
  placeholder,
  value,
  endDate,
  customClassNameForInput,
  disabled,
  onChange,
  error = false,
  errorMsg,
  maxLength,
  customClassName,
  size,
  inr,
  infoMessage = "",
  showDefaultTime = true,
}) => {
  const theme = createTheme({
    typography: {
      htmlFontSize: 10,
      fontFamily: "gilroyMedium",
    },
  });

  const selectedEndDate = dayjs(endDate);
  const selectedDateStr = selectedEndDate.format("YYYY-MM-DD");
  const now = dayjs();
  const isSameAsToday = selectedEndDate.isSame(now, "day");
  const referenceDate = selectedEndDate.isValid()
    ? selectedEndDate.hour(now.hour()).minute(now.minute()).second(now.second())
    : now;
  const selectedTime = value ? dayjs(value) : null;
  const pickerValue = selectedTime?.isValid()
    ? referenceDate.hour(selectedTime.hour()).minute(selectedTime.minute()).second(selectedTime.second()).millisecond(selectedTime.millisecond())
    : showDefaultTime && isSameAsToday ? now : null;

  const ref = useRef(null);
  useEffect(() => {
    // ref?.current?.onChange((e) => e.preventDefault());
  });
  dayjs.extend(utc);
  const mergeEndDateAndTime = (endDateString, endTimeString) => {
    const endDate = dayjs(endDateString);
    const endTime = dayjs(endTimeString, "HH:mm:ss.SSSSSS");

    const mergedTime = endDate
      .hour(endTime.hour())
      .minute(endTime.minute())
      .second(endTime.second())
      .millisecond(endTime.millisecond());

    const utcMergedTime = mergedTime
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss.SSSSSS[Z]");

    return utcMergedTime;
  };

  const handleTimeChange = (selectedTime) => {
    if (selectedTime === null) {
      onChange(null);
      return;
    }
    if (!selectedTime?.isValid() || !selectedEndDate.isValid()) return;
    const mergedTime = mergeEndDateAndTime(
      endDate,
      selectedTime.format("HH:mm:ss.SSSSSS"),
    );
    if (!isSameAsToday || !dayjs(mergedTime).isBefore(dayjs())) {
      onChange(mergedTime);
    }
  };

  return (
    <div
      className={`${styles.d_input_container} ${
        disabled ? styles.disabledField : ""
      } ${customClassName}`}
      style={{ width: `${size}` }}
    >
      <label>
        {label}
        {required && <span className={styles.requiredMark}>*</span>}
      </label>
      <div className={`${styles.d_input_wrapper} ${error ? styles.error : ""}`}>
        {type !== "time" && (
          <input
            type={type || "text"}
            value={value}
            onChange={onChange}
            maxLength={maxLength}
            className={`${customClassNameForInput}`}
            placeholder={!placeholder ? `Enter ${label}` : placeholder}
            disabled={disabled}
          />
        )}

        {type === "time" && (
          <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <MobileTimePicker
                key={selectedDateStr}
                ampm={true}
                format="hh:mm A"
                referenceDate={referenceDate}
                value={pickerValue}
                onChange={handleTimeChange}
                disablePast={isSameAsToday}
                disabled={disabled}
                onAccept={handleTimeChange}
                sx={{
                  width: "100%",
                  ".MuiOutlinedInput-notchedOutline": {
                    border: 0,
                  },
                }}
              />
            </LocalizationProvider>
          </ThemeProvider>
        )}
      </div>
      {infoMessage && (
        <div className={styles.infoMessageWrapper}>
          <InfoIcon sx={{ color: "#5b5d5b" }} />
          <p className={styles.infoMessage}>{infoMessage}</p>
        </div>
      )}
      {/* {inr && <p className={styles.show_count}>{inr}</p>} */}
      {error && <p className={styles.error_message}>{errorMsg}</p>}
    </div>
  );
};

export default memo(DTextInput);
